export default __webpack_public_path__ + "static/media/aaryan.11e566a3.png";